import styles from './SortByNum.module.scss';

export const DisplayedByNum = ({perPage, handleLimitChange}) => {
    return (
        <div className={styles['pagination__top']}>
            <select value={perPage} onChange={handleLimitChange}>
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
            </select>
        </div>
    );
};